<ng-container *ngIf="mode === 'icon'">
  <button
    *ngIf="!loading; else loadingButtonTmp"
    tuiIconButton
    type="button"
    [iconStart]="'@tui.arrow-down'"
    [appearance]="'outline-grayscale'"
    [size]="'m'"
    [style.border-radius.%]="100"
    (click)="downloadFile()"
  ></button>

  <ng-template #loadingButtonTmp>
    <tui-loader
      class="loader"
      [inheritColor]="false"
      [overlay]="false"
      [showLoader]="loading"
      (click)="stopFileDownload()"
    >
      <button
        tuiIconButton
        type="button"
        [iconStart]="'@tui.x'"
        [appearance]="'outline-grayscale'"
        [size]="'m'"
        [style.border-radius.%]="100"
      ></button>
    </tui-loader>
  </ng-template>
</ng-container>

<a *ngIf="mode === 'text'" tuiLink appearance="icon" size="xs" (click)="downloadFile()">
  {{ 'components.internalMessenger.buttons.download' | translate }}
</a>
